"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var banali_react_leaflet_1 = require("banali-react-leaflet");
require("leaflet-choropleth");
var usePrevious_1 = require("../../../../hooks/usePrevious");
var lodash_1 = require("lodash");
var leaflet_1 = __importDefault(require("leaflet"));
var style = {
    fillColor: '#008272',
    weight: 2,
    opacity: 1,
    color: 'white',
    dashArray: '3',
    fillOpacity: 0.5,
};
var Choropleth = function (_a) {
    var polygon = _a.polygon, isActiveMap = _a.isActiveMap, mapInitialCenter = _a.mapInitialCenter, isSubmitted = _a.isSubmitted;
    var map = banali_react_leaflet_1.useMap();
    var _b = react_1.useState(), geoJson = _b[0], setGeoJson = _b[1];
    var previousGeoJson = usePrevious_1.usePrevious(geoJson);
    react_1.useEffect(function () {
        map.fitBounds([[mapInitialCenter.lat, mapInitialCenter.lng]]);
        map.setZoom(14);
    }, [mapInitialCenter]);
    react_1.useEffect(function () {
        isSubmitted && map.setZoom(14);
    }, [isSubmitted]);
    react_1.useEffect(function () {
        if (polygon === null || polygon === void 0 ? void 0 : polygon.length) {
            var geoJson_1 = leaflet_1.default.geoJson({
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'MultiPolygon',
                            coordinates: [[polygon]],
                        },
                    },
                ],
            }, {
                valueProperty: 'incidents',
                scale: ['rgba(0, 0, 0, 0.5)', 'red'],
                steps: 5,
                mode: 'e',
                style: style,
            });
            setGeoJson(geoJson_1);
        }
    }, [polygon]);
    react_1.useEffect(function () {
        if (geoJson) {
            geoJson.addTo(map);
        }
        if (!lodash_1.isUndefined(previousGeoJson)) {
            map.removeLayer(previousGeoJson);
        }
    }, [geoJson]);
    react_1.useEffect(function () {
        if (isActiveMap) {
            map.dragging.enable();
            map.scrollWheelZoom.enable();
        }
        else {
            map.dragging.disable();
            map.scrollWheelZoom.disable();
        }
    }, [isActiveMap]);
    return null;
};
exports.default = Choropleth;
